import { gql, type TypedDocumentNode } from '@apollo/client';
import { type Address } from 'components/ProviderProfile/interfaces';

export const PROVIDER_ADDRESS_QUERY: TypedDocumentNode<ProviderAddressQueryData, ProviderAddressQueryVars> = gql`
    query PROVIDER_ADDRESS_QUERY($providerId: Long!) {
        provider(id: $providerId) {
            id
            providerId
            contactInfo {
                addresses {
                    countryCode
                    countryName
                    zIP_Postal
                    state_ProvinceCode
                    officeType
                }
                mailingAddresses {
                    countryCode
                    countryName
                    zIP_Postal
                    state_ProvinceCode
                    officeType
                }
            }
        }
    }
`

export interface ProviderAddressQueryData {
    provider: {
        id: number
        providerId: number
        contactInfo?: {
            addresses: Address[]
            mailingAddresses: Address[]
        }
    }
}

export interface ProviderAddressQueryVars {
    providerId: number
}
